import { render, staticRenderFns } from "./QueueBookingTable.vue?vue&type=template&id=184a6d76"
import script from "./QueueBookingTable.vue?vue&type=script&lang=js"
export * from "./QueueBookingTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports